"use client"

import toast from "react-hot-toast"
import { CancelButton } from "@src/components/Button"
import Icons from "../Icons"

const CopyLinkButton = ({ url = "" }) => {
  const handleCopyLink = () => {
    if (typeof window === "undefined") return
    navigator.clipboard.writeText(url)
    toast.success("Copied")
  }
  return (
    <CancelButton
      sx={{
        backgroundColor: "transparent !important",
        border: "none !important",
        padding: "0 !important",
        height: "auto !important",
        outline: "none !important",
        gap: "8px",
        "&:hover": {
          backgroundColor: "transparent !important",
          color: "#000 !important"
        },
        "& .MuiTouchRipple-root": {
          bgcolor: "transparent !important"
        }
      }}
      startIcon={
        <Icons
          name="link"
          sx={{
            padding: "0 !important"
          }}
        />
      }
      label="Copy link"
      onClick={handleCopyLink}
    />
  )
}

export default CopyLinkButton
